<div>
  <p class="title">¿Seguro desea aprobar este caso?</p>
  <div class="buttons">
    <button mat-raised-button (click)="close(false)" class="cancel-btn rounded">
      Cancelar
    </button>
    <button mat-raised-button (click)="close(true)" class="primary-btn rounded">
      Aprobar
    </button>
  </div>
</div>
